// This modal centering code was grabbed from this stack overflow thread. Modified to fit our use and code patterns.
// https://stackoverflow.com/questions/4068373/center-a-popup-window-on-screen
// Code's original credit: http://www.xtf.dk/2011/08/center-new-popup-window-even-on.html
export function popupCenter(url: string, title: string, w: number, h: number, resizeable: boolean) {
    // Fixes dual-screen position
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

    let width;
    if (window.innerWidth) {
        width = window.innerWidth;
    } else if (document.documentElement.clientWidth) {
        width = document.documentElement.clientWidth;
    } else {
        width = screen.width;
    }

    let height;
    if (window.innerHeight) {
        height = window.innerHeight;
    } else if (document.documentElement.clientHeight) {
        height = document.documentElement.clientHeight;
    } else {
        height = screen.height;
    }

    const systemZoom = width / window.screen.availWidth;
    const left = (width - w / 1.5) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;

    const newWindow = window.open(
        url,
        title,
        `scrollbars=${resizeable},
            width=${w},
            height=${h},
            resizable=${resizeable},
            toolbar=${resizeable},
            menubar=no,
            status=no,
            directories=no,
            top=${top},
            left=${left}`,
    );

    newWindow?.focus();
    return newWindow;
}
